document.addEventListener("DOMContentLoaded", function () {

    const productDataEl = document.getElementById('FeaturedProductData');
    if (productDataEl) {
        window.globalVariables = window.globalVariables || {};
    try {
        window.globalVariables.product = JSON.parse(productDataEl.getAttribute('data-product'));
    } catch (e) {
        console.error("Unable to parse product from FeaturedProductData", e);
    }
    }
    document.querySelectorAll(".quantity__button").forEach(button => {
        const quantityInput = button.closest("quantity-input").querySelector(".quantity__input");

        let { price: unitPrice, compareAtPrice: unitComparePrice } = getUnitPrice();
        let discountPercentage = getDiscountPercentage();

        button.addEventListener("click", function () {
            const quantityCount = parseInt(quantityInput.value) || 1;
            updatePrices(quantityCount, unitPrice, unitComparePrice, discountPercentage);
        });

        quantityInput.addEventListener("input", function () {
            const quantityCount = parseInt(this.value) || 1;
            updatePrices(quantityCount, unitPrice, unitComparePrice, discountPercentage);
        });

        document.addEventListener("change", function (event) {
            if (event.target.closest(".product-variant-id")) {
                let prices = getUnitPrice();
                unitPrice = prices.price;
                unitComparePrice = prices.compareAtPrice;
                discountPercentage = getDiscountPercentage();
            }
        });
    });

    function getUnitPrice() {
        const variantSelect = document.querySelector(".product-variant-id");
        if (variantSelect) {
            const selectedVariantId = parseInt(variantSelect.value, 10);
            const selectedVariant = window.globalVariables.product.variants.find(v => v.id == selectedVariantId);
            if (selectedVariant) {
                return {
                    price: selectedVariant.price / 100,
                    compareAtPrice: selectedVariant.compare_at_price ? selectedVariant.compare_at_price / 100 : 0
                };
            }
        }
        return { price: 0, compareAtPrice: 0 };
    }

    function getDiscountPercentage() {
        const discountContainer = document.querySelector("[data-abtest-price]");
        return discountContainer ? parseFloat(discountContainer.getAttribute("data-abtest-price")) || 0 : 0;
    }

    function updatePrices(quantityCount, unitPrice, compareAtPrice, discountPercentage) {
        const totalPrice = unitPrice * quantityCount;
        const totalComparePrice = compareAtPrice * quantityCount;
        const totalAbtestDiscount = totalPrice * (discountPercentage / 100);
        const totalAbtestPrice = totalPrice - totalAbtestDiscount;

        const formattedTotal = Shopify.formatMoney(totalPrice * 100, window.globalVariables.money_format_currecy);
        const formattedCompareTotal = Shopify.formatMoney(totalComparePrice * 100, window.globalVariables.money_format_currecy);
        const formattedAbtestPrice = Shopify.formatMoney(totalAbtestPrice * 100, window.globalVariables.money_format_currecy);

        document.querySelector("[data-currentPrice]").textContent = formattedTotal;
        if (compareAtPrice > 0) {
            document.querySelector("[data-comparePrice]").textContent = formattedCompareTotal;
        }

        document.querySelector("[data-currentPrice-abtest]").textContent = formattedAbtestPrice;
        document.querySelector("[data-comparePrice-abtest]").textContent = formattedTotal;
    }
});
